import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PhotosGalleryComponent } from './photos-gallery.component';

@NgModule({
  declarations: [
    PhotosGalleryComponent
  ],
  exports: [
    PhotosGalleryComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})

export class PhotosGalleryModule {
  constructor() {}
}
